import BaseCollection from '@/collections/BaseCollection';

/**
 * Crm service base collection class
 */
export default class CrmServiceCollection extends BaseCollection {

  constructor(){
    super();
  }

  // Route configuration
  privateRoutes() {
    let model = (new (this.model())());
    return {
      fetch: process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/' + model.modelName(),
    }
  }
}
